export const ReleaseNotes = ({props}) => {
    return <div style={{textAlign: 'left'}}>
        <div>Version 1.6.9 Release 10-20-2026</div>
        <ul>
            <li>- Add CSV output for Batch Sales Report</li>
        </ul>
        <div>Version 1.6.8 Release 10-19-2026</div>
        <ul>
            <li>- Fix issue with inventory search that was introduced with last commit</li>
        </ul>
        <div>Version 1.6.7 Release 10-18-2026</div>
        <ul>
            <li>- Fix issue with Cultivation Harvest Form, double click caused multiple data entries</li>
            <li>- Add Batch Sales Report for Operations</li>
        </ul>
        <div>Version 1.6.6 Release 10-16-2026</div>
        <ul>
            <li>- Fix legacy Batch/Bulk Wholesale Form</li>
            <li>- total cost was too high by 10x</li>
        </ul>
        <div>Version 1.6.5 Release 10-14-2026</div>
        <ul>
            <li>- Implement Operations Reports Page</li>
            <li>- implement batch report to report out trim results by Batch/Harvest</li>
            <li>- implement save CSV for operations batch report</li>
        </ul>
        <div>Version 1.6.4 Release 10-12-2026</div>
        <ul>
            <li>Fix for Cultivation</li>
            <li>- strain selection requires 2 characters now, not 3</li>
            <li>- fixes issue because we have a strain named "OG"</li>
        </ul>
        <div>Version 1.6.3 Release 10-07-2026</div>
        <ul>
            <li>Fix for Arvin</li>
            <li>- support for post endpoint for user login</li>
        </ul>
        <div>Version 1.6.2 Release 09-29-2026</div>
        <ul>
            <li>Outside Sales UI</li>
            <li>- improve outside sales inventory table to use product photos</li>
            <li>- implement basic search for outside sales inventory</li>
        </ul>
        <div>Version 1.6.1 Release 09-21-2026</div>
        <ul>
            <li>Feature Update</li>
            <li>- implement mobile ui at '/mobile' url</li>
            <li>- support Tasks module in mobile ui</li>
            <li>- implement image upload for Products in product details page</li>
        </ul>
        <div>Version 1.6.0 Release 09-10-2026</div>
        <ul>
            <li>Update for Cultivation</li>
            <li>- rebuild cultivation, simplify to flower and dry rooms only</li>
            <li>- implement page and entries for Plant Strains</li>
            <li>- expand the information stored in Plant Batch / Run</li>
        </ul>
        <div>Version 1.5.25 Release 08-27-2026</div>
        <ul>
            <li>Update for Fulfillment</li>
            <li>- quality of life fix for @Desi</li>
            <li>- Allow Purchase Order Line Items to be delete as long as they have not been fulfilled</li>
            <li>- just changing the state of the line item will no longer prevent deletion</li>
            <li>Update for Admin</li>
            <li>- fix issue with setting user active/inactive</li>
        </ul>
        <div>Version 1.5.24 Release 08-20-2026</div>
        <ul>
            <li>Bug Patch for Sales/Fulfillment</li>
            <li>- fix issue with PO | Create Invoice</li>
            <li>- adapt it to the new create invoice api, fix issue where invoice was empty</li>
            <li>- TY @Rick @Desi for the nice bug find.</li>
        </ul>
        <div>Version 1.5.23 Release 08-17-2026</div>
        <ul>
            <li>Tasks</li>
            <li>- any user can change due date</li>
            <li>- changing due date requires a note.</li>
            <li>Payments</li>
            <li>- payment notes can now be 2048 characters</li>
            <li>Inventory/Sales</li>
            <li>- inventory type and subtype are searchable</li>
            <li>Update Sales UI</li>
            <li>- simplify Create New Invoice, add items once the invoice is created</li>
            <li>- removes difficult to understand timer when creating invoice</li>
            <li>Update For Cultivation</li>
            <li>- add Transfer button to transfer multiple plants from rooms page</li>
        </ul>
        <div>Version 1.5.22 Release 08-06-2026</div>
        <ul>
            <li>Updates for Admin</li>
            <li>- Fix Issue Creating New user</li>
            <li>- creating new users was broken after adding per user custom permissions</li>
        </ul>
        <div>Version 1.5.21 Release 07-28-2026</div>
        <ul>
            <li>Updates for Fulfillment</li>
            <li>- implement line item time costs for Purchase Order fulfillment</li>
            <li>- items are editable only by the original author</li>
            <li>- individual packaged product line items still have their own hours recorded</li>
            <li>Updates for Accounting</li>
            <li>- Purchase Order Report Updated to include line item hours spent on Purchase Order</li>
            <li>- individual PO items are still have a time recorded</li>
        </ul>
        <div>Version 1.5.20 Release 07-22-2026</div>
        <ul>
            <li>Updates for Inventory</li>
            <li>- implement self service 'Save CSV' button to save Inventory Product List</li>
            <li>- implement 'Save CSV' for Inventory List as well</li>
        </ul>
        <div>Version 1.5.19 Release 07-21-2026</div>
        <ul>
            <li>Updates for Sales</li>
            <li>- improve UI for adding items in Inventory View</li>
            <li>- make it comparable to the ui for creating Invoice</li>
            <li>Update for Accounting/Executives</li>
            <li>- improve Purchase Order Report, allow search by buyer</li>
        </ul>
        <div>Version 1.5.18 Release 07-16-2026</div>
        <ul>
            <li>Fix for Inventory</li>
            <li>- add support for editing bulkSize for Wholesale Products</li>
        </ul>
        <div>Version 1.5.17 Release 07-09-2026</div>
        <ul>
            <li>Cash Flow Report for Accounting/Executive</li>
            <li>- find the report under Accounting | Report | Cash Flow Report</li>
            <li>- provide report for transactions over a selected time period</li>
            <li>Buyer Payments View</li>
            <li>- Display view for all payments from a given buyer</li>
            <li>- Find the link under Buyers | Balances Due | Payments'
            </li>
        </ul>
        <div>Version 1.5.16 Release 07-08-2026</div>
        <ul>
            <li>Purchase Order Report for Accounting/Executive</li>
            <li>- find the report under Accounting | Report | Purchase Order Report</li>
            <li>- provide summarized and detailed view for PO time/cost breakdown</li>
        </ul>
        <div>Version 1.5.15 Release 07-07-2026</div>
        <ul>
            <li>Upgrades for Fulfillment</li>
            <li>- Add Inventory Description field for lots of inventory</li>
            <li>- Do not allow duplicate products in each Purchase Order</li>
            <li>Upgrades for Cultivation</li>
            <li>- Add support for deleting room data via CSV.</li>
            <li>- Add support for deleting data via light CSV.</li>
            <li>General/User Upgrades</li>
            <li>- users can change their own passwords from General | Change Password</li>
            <li>- admins can change permission levels for specific users</li>
            <li>- each user now has their own access permissions</li>
        </ul>
        <div>Version 1.5.14 Release 07-01-2026</div>
        <ul>
            <li>Deploy Cultivation App to Prod</li>
            <li>- Cultivation App and Data deployed to Prod</li>
            <li>- Cultivation Data is replicated from staging as of 7.01.2026</li>
            <li>- workaround to give Rick access to cultivation</li>
        </ul>
        <div>Version 1.5.13 Release 06-29-2026</div>
        <ul>
            <li>Fix for Task Edits Not Updating</li>
            <li>- tasks should reflect edits instantly without refresh</li>
            <li>Fix for Invoice/Cart Clear</li>
            <li>- allow user to clear cart items for all outstanding sessions</li>
            <li>- fixes issue where General | Inventory Reserve does not show items from all sessions</li>
            <li>- fixes issue that Rick found, by using multiple windows</li>
        </ul>
        <div>Version 1.5.12 Release 06-24-2026</div>
        <ul>
            <li>Improvements for Invoices</li>
            <li>- Chanel's look and feel improvements to printed PDF view</li>
        </ul>
        <div>Version 1.5.11 Release 06-05-2026</div>
        <ul>
            <li>Improvements for Tasks</li>
            <li>- save top level Task filter state when navigating out</li>
            <li>- improve Task notification emails with more info</li>
        </ul>
        <div>Version 1.5.10 Release 06-03-2026</div>
        <ul>
            <li>Improvements for Inventory</li>
            <li>- moved Batch screen to Inventory (previously in admin)</li>
            <li>- use just the date (skip time) when auto generating sku</li>
        </ul>
        <div>Version 1.5.9 Release 05-26-2026</div>
        <ul>
            <li>Improvements for Inventory</li>
            <li>- insert user entered notes when adjusting inventory</li>
            <li>- notes are mandatory to force users to justify adjustments</li>
        </ul>
        <div>Version 1.5.8 Release 05-21-2026</div>
        <ul>
            <li>Improvements for Accounting</li>
            <li>- Add support for Batch Report</li>
        </ul>
        <div>Version 1.5.7 Release 05-21-2026</div>
        <ul>
            <li>Improvements for Accounting</li>
            <li>- Add total cost column to COGS Report</li>
        </ul>
        <div>Version 1.5.6 Release 05-20-2026</div>
        <ul>
            <li>Improvements for Inventory</li>
            <li>- Users can clear their inventory cart/reserve from General tab.</li>
            <li>- Admins can monitor system inventory cart/reserve from Admin tab.</li>
        </ul>
        <div>Version 1.5.5 Release 05-15-2026</div>
        <ul>
            <li>Fixes for Accounting</li>
            <li>- fix issue where Transaction view was broken.</li>
            <li>- allow transactions to be edited to $0 amount.</li>
        </ul>
        <div>Version 1.5.4 Release 05-15-2026</div>
        <ul>
            <li>Feature Request for Fulfillment</li>
            <li>- allow for 2.0 g subtype for flower</li>
            <li>- allow for 2.0 g subtype for preroll</li>
        </ul>
        <div>Version 1.5.3 Release 05-13-2026</div>
        <ul>
            <li>Feature Requests for Sales/Accounting</li>
            <li>- add ability to change invoice payment amounts and accounts under some conditions</li>
            <li>- add the ability to back date transfer transactions in accounting</li>
            <li>- added total cost to COGS report</li>
            <li>Feature Requests for Executive</li>
            <li>- increase the size of Purchase Order description</li>
            <li>- bonus feature: add the ability to edit the description</li>
        </ul>
        <div>Version 1.5.2 Release 05-08-2026</div>
        <ul>
            <li>Hotfix Fulfillment/Sales</li>
            <li>- add ability to change purchase order line item quantities under some conditions</li>
            <li>- quantity can only be modified if the line item is not complete yet</li>
        </ul>
        <div>Version 1.5.1 Release 05-07-2026</div>
        <ul>
            <li>Hotfix Fulfillment</li>
            <li>- fix issue where sort for purchase order caused "create invoice" to fail</li>
        </ul>
        <div>Version 1.5.0, Release 05-02-2026</div>
        <ul>
            <li>Updates for Fulfillment</li>
            <li>- add column sort/search for purchase order view</li>
            <li>- adds undo feature for purchase order line items</li>
            <li>- undo allows error correction, will restore inventory</li>
            <li>Updates for Accounting/Sales</li>
            <li>- decrease the number of invoice views,  now open/completed</li>
            <li>- open invoices has everything up to and including fully paid</li>
            <li>Updates for Tasks/Operations</li>
            <li>- TaskTable is now stateful,  will remember sort order and filter state</li>
            <li>- Task Notes are editable by the original poster</li>
            <li>- new custom filter widget for task status column</li>
        </ul>
        <div>Version 1.4.19, Release 04-20-2026</div>
        <ul>
            <li>Updates for Accounting</li>
            <li>- allow non invoice payments to be backdated</li>
            <li>- allow most payment options to be updated</li>
            <li>- update vendor select widget to have autocomplete</li>
        </ul>
        <div>Version 1.4.18, Release 04-16-2026</div>
        <ul>
            <li>Fix Issue with Buyer Select Widget</li>
            <li>- fixes issue where choices get corrupt when scrolling</li>
        </ul>
        <div>Version 1.4.17, Release 04-15-2026</div>
        <ul>
            <li>Accounting improvements for Tanya</li>
            <li>- display transactions by `date`, allowing for back dating</li>
            <li>- add search for bank account view columns</li>
            <li>- fix issue with New Expense Form,  the backdating field will clear now after a new expense is filed</li>
            <li>- note that the "vendor" isn't an easy fix.  You need to click the vendor again when filing multiple expenses</li>
        </ul>
        <ul>
            <li>External Sales Changes</li>
            <li>- allow External Sales to file Purchase Orders</li>
            <li>- allow External Sales to view their own Purchase Orders</li>
        </ul>
        <div>Version 1.4.16, Release 04-09-2026</div>
        <ul>
            <li>Improvements to Inventory</li>
            <li>- add search and sort for sku column</li>
        </ul>
        <div>Version 1.4.15, Release 04-08-2026</div>
        <ul>
            <li>Improvements to Completed Invoice</li>
            <li>- add search for invoice name, and buyer</li>
            <li>- add sort to balance column</li>
        </ul>
        <div>Version 1.4.14, Release 03-28-2026</div>
        <ul>
            <li>Fix Crashes in Inventory Type / Subtype sorting</li>
            <li>- fixes crash when clicking column header to sort</li>
            <li>Update COGS Report</li>
            <li>- add support for Testing cost in COGS report</li>
        </ul>
        <div>Version 1.4.13, Release 03-22-2026</div>
        <ul>
            <li>Add Support for Tracking Testing in inventory</li>
            <li>- Update for ProductType and ProductSubtype</li>
            <li>- introduce new product type of "test", which can have subtype "test"</li>
            <li>- also adding product type "supply", with subtypes "container", "sticker", "miscellaneous"</li>
        </ul>
        <div>Version 1.4.12, Release 03-15-2026</div>
        <ul>
            <li>First Implementation of COGS Report</li>
            <li>- located in Accounting | COGS Report</li>
            <li>- will report all Packaged Products created through Fulfillment for a time period</li>
        </ul>
        <div>Version 1.4.11, Release 03-13-2026</div>
        <ul>
            <li>Hotfix for Rick/Desi</li>
            <li>- Fix issue where setting tariff, shipping, etc.. in cost dialog does not work</li>
        </ul>
        <div>Version 1.4.10, Release 03-10-2026</div>
        <ul>
            <li>Improvements to Fulfillment UI</li>
            <li>- Filter Inventory Assignment Widget,  do not display inventory that has insufficient quantity</li>
            <li>- helps PO Line Item form, and for Purchase Order (autogen invoice feature)</li>
            <li>- fix issue with CompletedPOLineItemView,  remove references to old bookInventoryId columns</li>
        </ul>
        <div>Version 1.4.9, Release 03-09-2026</div>
        <ul>
            <li>Fulfillment Updates to support COGS</li>
            <li>- Purchase Order Line Items can now only be book or only be non-book (previously can choose both)</li>
            <li>- Fulfillment UI changed slightly to allow a checkbox for book</li>
        </ul>
        <div>Version 1.4.8, Release 03-03-2026</div>
        <ul>
            <li>Fixes for Rick</li>
            <li>- Remove proprietary information from invoice PDF Printed view</li>
            <li>- Make Buyers|Balances Due page link to more details about the buyer's invoices</li>
            <li>- create new Buyer Balance view</li>
        </ul>
        <div>Version 1.4.7, Release 02-22-2026</div>
        <ul>
            <li>Fixes from Sam</li>
            <li>- update the Product Info page to contain links to all Inventory for this Product</li>
            <li>- update how skus are saved, have fewer "null" skus in fulfillment</li>
        </ul>
        <div>Version 1.4.6, Release 02-17-2026</div>
        <ul>
            <li>Hotfix for Rick</li>
            <li>- fix issue where invoice totals were incorrect under certain conditions</li>
            <li>- add sort to invoice view item names, to make it easier to find line items for long invoices</li>
            <li>- did not give you SEARCH because that would make the invoice view too confusing..</li>
            <li>- if you add an item, it still won't be the last one,  but at least you can sort and find it</li>
        </ul>
        <div>Version 1.4.5, Release 02-16-2026</div>
        <ul>
            <li>Hotfix for Abe</li>
            <li>- fix Task due labels incorrect under certain conditions</li>
        </ul>
        <div>Version 1.4.4 Release</div>
        <ul>
            <li>Hotfixes for Desi</li>
            <li>- fix issue where PO ingredient hints would disappear unexpectedly</li>
            <li>- fix off by 1 in newTask due date</li>
            <li>Fix for Jocelyn</li>
            <li>- add task tabs to render state</li>
            <li>- allows for browser navigation back to the proper task sub page</li>
            <li>Fix Purchase Order title search</li>
            <li>- fix search, it was broken</li>
        </ul>
        <div>Version 1.4.3 Release</div>
        <ul>
            <li>Use 12 hour time system instead of 24 hour</li>
            <li>Add More Transaction Info for Bank Accounts</li>
            <li>- add supplemental "Other" information for Expense and Invoice Payments</li>
            <li>Allow dates to be changed from Task table when possible</li>
            <li>- changeable by owner, changeable by ops</li>
            <li>- can not be changed if task is verified</li>
            <li>Fix for Dates off by 1</li>
            <li>- present datetime as MM-DD-YYYY-HH:MM:SS</li>
        </ul>
        <div>Version 1.4.2 Release</div>
        <ul>
            <li>Hotfixes for Desi</li>
            <li>- fix mission critical issue related to PO-2026-11</li>
        </ul>
        <div>Version 1.4.1 Release</div>
        <ul>
            <li>Hotfixes for Abe</li>
            <li>- fix issue where verified Tasks can not be displayed</li>
            <li>- fix counts for All Tasks, counts should not included verified tasks</li>
            <li>Hotfixes for Desi</li>
            <li>- fix issue where really large PO could not generate an invoice</li>
        </ul>
        <div>Version 1.4 Release</div>
        <ul>
            <li>New Feature: Add e-mails for Users</li>
            <li>- add tables and form for updating user's email</li>
            <li>- add BETA support for task assignment/following email notifications</li>
            <li>New Feature: Allow Packaged Products to Have Ingredients</li>
            <li>- Find the UI under Product info page in "Inventory | Products | (search & click packaged product)"</li>
            <li>- add ingredient products in Product info page</li>
            <li>- PO items for the packaged product will appear as hints in Fulfillment's PO Item form</li>
            <li>- PO Item form has been changed slightly,  quantity produced must be entered as a first step.</li>
            <li>Sales</li>
            <li>- Rebuild UI for New Invoice</li>
            <li>- new search widget for higher visibility</li>
            <li>- add Paid invoice and Complete Invoice choices in Sales</li>
            <li>- add Complete invoice in Accounting</li>
            <li>- completed invoices can not be modified (besides by executive)</li>
            <li>Operations</li>
            <li>- Allow Operations and Executives to Verify all Tasks</li>
            <li>- Allow Operations and Executives to Change Dates and otherwise modify Tasks</li>
            <li>Accounting</li>
            <li>- add ability to invalidate payments</li>
            <li>- improve Profit Report to show list of expenses and payments</li>
            <li>- spruce up bank transactions table</li>
            <li>Add Support for Outside Sales</li>
            <li>- create a new outside sales department</li>
            <li>- allow access for wholesale/packaged inventory</li>
            <li>- allow creation of PO.</li>
            <li>- only allow viewing of POs owned by the Outside Sales Team Member</li>
            <li>Bug Fixes</li>
            <li>- make alert level match human intuitive, so it doesn't appear off by 1</li>
            <li>- Fix Inventory Search Widget, don't reset options when window refreshes</li>
            <li>- fix off by 10 issue in invoice print view</li>
            <li>- Filter inactive users from user select widget</li>
            <li>Fix for Completed PO Line Item Details, fix issue where link(s) are missing if all items are book</li>
            <li>Look & Feel</li>
            <li>- reorder Task Columns, correct capitalization of "By"</li>
            <li>- Task Alert colors, overdue is red, due today is orange, due soon is blue </li>
            <li>- make User Select widget less annoying,  make it clear after each selection</li>
        </ul>
        <div>Version 1.3.8</div><p/>
        <ul>
            <li>Hot fix for Abe</li>
            <li>Reorder Task Columns</li>
            <li>- modify specific order of task columns</li>
        </ul>
        <div>Version 1.3.7</div><p/>
        <ul>
            <li>Hot fix for Desiree</li>
            <li>Fix issue with Product Search Widget</li>
            <li>- widget list becomes corrupt,  and won't display correctly</li>
        </ul>
        <div>Version 1.3.7</div><p/>
        <ul>
            <li>Hot fix for Desiree</li>
            <li>Prevent Failure Issue when completing PO Items</li>
            <li>- Failure was caused by ingredient cost being null or undefined</li>
            <li>- Attempt to fail cleanly by providing 0 cost in this case to back end</li>
            <li>Fix Issue Computing PO Line Item Cost</li>
            <li>- fix type error for bulkCost for bulk ingredients</li>
        </ul>
        <div>Version 1.3.6</div><p/>
        <ul>
            <li>Hot fix for Desiree, Hot fix for Abe</li>
            <li>Fix issue with New Wholesale product</li>
            <li>- off by 10 issue again for 0.1g support </li>
            <li>Fix for Task Column sorting</li>
            <li>- fix crash when attempting to sort by Task Title </li>
        </ul>
        <div>Version 1.3.5</div><p/>
        <ul>
            <li>Hot fix for Abe</li>
            <li>Fix issue with Datepicker months</li>
            <li>- allow the picker to choose next months </li>
        </ul>
        <div>Version 1.3.4</div><p/>
        <ul>
            <li>Hot fix for Reza</li>
            <li>Add Sub-types for Packaged Products</li>
            <li>- add 1.5 g choice for prerolls</li>
            <li>- add .5 g choice for extracts</li>
        </ul>
        <div>Version 1.3.3</div><p/>
        <ul>
            <li>Hot fix for Rick</li>
            <li>Fix Invoice View Issue</li>
            <li>- fix off by 10 issue when adding invoice items in invoice view</li>
        </ul>
        <div>Version 1.3.2</div><p/>
        <ul>
            <li>Fixes from Reza</li>
            <li>Fulfillment PO Line Item Navigation</li>
            <li>- navigate to Purchase Order after Completing Line Item</li>
            <li>Spruce up Fulfillment | Requested Items Table</li>
            <li>- add sorting and search to select columns in this table</li>
        </ul>
        <div>Version 1.3.1</div><p/>
        <ul>
            <li>New Features</li>
            <li>Support Followers for Tasks</li>
            <li>- tasks can support multiple follower users</li>
            <li>- followers can be added and removed at task creation and at task view</li>
            <li>- Tasks tab has a page for listing `Followed` Tasks</li>
        </ul>
        <div>Version 1.3</div><p/>
        <ul>
            <li>New Features</li>
            <li>Rebuild Fulfillment | Purchase Order Line Item UI</li>
            <li>- all new widgets to select Bulk and Supply Ingredients</li>
            <li>- items are searchable from one screen</li>
            <li>- all new widgets to select items and set quantities</li>
            <li>Tasks Supported in Purchase Orders</li>
            <li>- POs can now have associated Tasks</li>
            <li>- new PO and PO view will now allow creation and display of Tasks</li>
            <li>Bug Fixes</li>
            <li>Fix bugs caused by 0.1 g support</li>
            <li>- Fix issue with Bulk Inventory Forms showing incorrect quantities</li>
            <li>- Fix issue with New Invoice Crashing on adding large quantities</li>
            <li>Task UI Bug</li>
            <li>- Fix off by 1 issue with datepicker in New Task</li>
        </ul>
        <div>Version 1.2</div><p/>
        <ul>
            <li>Further Improvements</li>
            <li>Inventory Support for 0.1 g</li>
            <li>- Bulk Inventory now supports fractional grams 0.1 g</li>
            <li>- Modified all inventory/invoice/PO/returns to support fractional grams</li>
            <li>- Sales limited to selling 1.0 g</li>
            <li>- Fulfillment can extract 0.1 g</li>
            <li>Buyer/Vendor Improvements</li>
            <li>- Add Support for selecting primary contact info for email/address/phoneNumber</li>
        </ul>
        <div>Version 1.1</div><p/>
        <ul>
            <li>Improvements from team feedback from Version 1.0</li>
            <li>Invoice</li>
            <li>- New Invoice Print to PDF feature</li>
            <li>- PDF can be saved to file or printed via browser or Acrobat, etc.</li>
            <li>Users</li>
            <li>- fix issue where new department values was erroring out</li>
            <li>- update New User ui, add error checking</li>
            <li>- move User Tab under Admin Tab</li>
            <li>- add ability to disable user accounts</li>
            <li>Inventory</li>
            <li>- link out from inventory view to ease modification of properties</li>
            <li>- add ability to modify cost information for inventory</li>
            <li>- Prevent Duplicate Products, add Product Lookup While Creating</li>
            <li>Add Automatic Data Refresh</li>
            <li>- refresh set to 30 seconds</li>
            <li>- this should help for 2 users, or 2 open window for 1 user.</li>
            <li>Task Improvements</li>
            <li>- Task description increased to 10kb</li>
            <li>- Task notes increased to 2kb</li>
            <li>- Add Department Task lists to department pages, viewable by exec and ops</li>
            <li>- 12.1.2025 only allow Verified Status for Task Owner</li>
            <li>- 12.1.2025 add colorful Alerts for Tasks due a) Today and b) Tomorrow</li>
            <li>- 12.1.2025 add filter options for Alerted Tasks</li>
            <li>- 12.1.2025 add colorful Badge at the top level Task Tab for alert count</li>
            <li>Purchase Orders</li>
            <li>- Add Purchase Order Items directly to an Invoice</li>
            <li>- from Purchase Order View,  Sales/Fulfillment must assign each line to an inventory item (if there is no assignment), this will enable 1-click Invoice creation</li>
            <li>Book</li>
            <li>- Improve Support for Book flag</li>
            <li>- Add Book flag to inventory table</li>
            <li>- Allow users to modify book value in inventory view</li>
            <li>- Allow Fulfillment to specify book quantity when creating PO Line Items/Inventory Items</li>
        </ul><p/>
        <div>Version 1.0</div><p/>
        <ul>
            <li>First Feature Complete Release</li>
            <li>- Code Release from 11.06.2025</li>
            <li>- We are labeling code from this date as the first official release that is feature complete.</li>
        </ul><p/>
    </div>
}